'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactBootstrap = require('react-bootstrap');
var ErrorBoundary_module = require('./ErrorBoundary.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * The concept of ErrorBoundary component is similar to the try/catch behaviour.
 * It will wrap other element and catch error/exceptions raised by those and display a nice
 * UI when an error occurs.
 */
class ErrorBoundary extends React__default["default"].Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false, showDetails: false };
        this.toggleDetails = () => {
            this.setState((prevState) => (Object.assign(Object.assign({}, prevState), { showDetails: !prevState.showDetails })));
        };
    }
    static reportError(error, info) {
        // eslint-disable-next-line no-console
        console.error(error, info);
        // Send to Splunk?
    }
    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({
            hasError: true,
            error,
            info,
        });
        // You can also log the error to an error reporting service
        ErrorBoundary.reportError(error, info);
    }
    render() {
        const { name } = this.props;
        const { hasError, error, info, showDetails } = this.state;
        const { children } = this.props;
        if (hasError) {
            // You can render any custom fallback UI
            return (React__default["default"].createElement("div", { className: ErrorBoundary_module["default"].boundary },
                React__default["default"].createElement("h2", null,
                    "Unexpected error occurred ",
                    name && `in ${name}`),
                React__default["default"].createElement("h4", null, error && (React__default["default"].createElement("span", null,
                    error.name,
                    " - ",
                    error.message))),
                showDetails && (React__default["default"].createElement("div", { className: ErrorBoundary_module["default"].details },
                    React__default["default"].createElement("pre", null, info && info.componentStack))),
                React__default["default"].createElement(reactBootstrap.Button, { size: "sm", variant: "outline-secondary", onClick: this.toggleDetails },
                    showDetails ? 'Hide' : 'Show',
                    " details")));
        }
        return children;
    }
}
ErrorBoundary.defaultProps = { name: 'Guarded component' };

exports["default"] = ErrorBoundary;
